import {
  SupportBugKind,
  SupportCustomerSegment,
  SupportPulseStatus,
  SupportTicketArea,
  SupportTicketIntent,
  SupportTicketPriority,
} from '../support';
import { validateEnumTranslations } from '../../safety_checks';

// Libellés fr-FR des enums du triage support (intention, domaine, priorité, nature
// d'un bug, statut de la suggestion Pulse). Lus par le front (badges) ET par le
// backend (note privée Chatwoot construite depuis MAPPED_TRANSLATION, jamais en dur).

export const TRANSLATE_KEY_SUPPORT_TICKET_INTENT = 'SUPPORT_TICKET_INTENT_';

export const SupportTicketIntentTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.QUESTION}`]: 'Question',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.BUG}`]: 'Bug',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.EVOLUTION}`]: 'Évolution',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.FACTURATION}`]: 'Facturation',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.COMPTE}`]: 'Compte',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.COMMERCIAL}`]: 'Commercial',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_INTENT}${SupportTicketIntent.AUTRE}`]: 'Autre',
  },
};

export const TRANSLATE_KEY_SUPPORT_TICKET_AREA = 'SUPPORT_TICKET_AREA_';

export const SupportTicketAreaTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.AGENDA}`]: 'Agenda',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.RESERVATION}`]: 'Réservation',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.CLIENTS}`]: 'Clients',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.CATALOGUE}`]: 'Catalogue',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.SITE_WEB}`]: 'Site web',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.DOMAINE_EMAIL}`]: 'Domaine et e-mail',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.PAIEMENT_CLIENT}`]: 'Paiement client',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.NOTIFICATIONS}`]: 'Notifications',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.MOBILE}`]: 'Application mobile',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.MIGRATION_V1}`]: 'Migration v1',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.PULSE}`]: 'Pulse',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_AREA}${SupportTicketArea.AUTRE}`]: 'Autre',
  },
};

export const TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY = 'SUPPORT_TICKET_PRIORITY_';

export const SupportTicketPriorityTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY}${SupportTicketPriority.URGENT}`]: 'Urgente',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY}${SupportTicketPriority.HIGH}`]: 'Haute',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY}${SupportTicketPriority.MEDIUM}`]: 'Moyenne',
    [`${TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY}${SupportTicketPriority.LOW}`]: 'Basse',
  },
};

export const TRANSLATE_KEY_SUPPORT_BUG_KIND = 'SUPPORT_BUG_KIND_';

export const SupportBugKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_BUG_KIND}${SupportBugKind.DEFECT}`]: 'Défaut probable',
    [`${TRANSLATE_KEY_SUPPORT_BUG_KIND}${SupportBugKind.PROBABLE_CONFIG}`]: 'Problème de configuration probable',
  },
};

export const TRANSLATE_KEY_SUPPORT_PULSE_STATUS = 'SUPPORT_PULSE_STATUS_';

export const SupportPulseStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.NONE}`]: 'Sans analyse',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.PENDING}`]: 'Analyse en cours',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.SUGGESTED}`]: 'Suggestion proposée',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.ACCEPTED}`]: 'Suggestion acceptée',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.REJECTED}`]: 'Suggestion refusée',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.REJECTED_IMPLICIT}`]:
      'Suggestion ignorée (le pro a répondu)',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.SKIPPED}`]: 'Aucune suggestion',
    [`${TRANSLATE_KEY_SUPPORT_PULSE_STATUS}${SupportPulseStatus.FAILED}`]: 'Analyse en échec',
  },
};

export const TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT = 'SUPPORT_CUSTOMER_SEGMENT_';

export const SupportCustomerSegmentTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT}${SupportCustomerSegment.ESSAI}`]: 'En essai',
    [`${TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT}${SupportCustomerSegment.NOUVEAU}`]: 'Nouveau client',
    [`${TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT}${SupportCustomerSegment.ETABLI}`]: 'Client établi',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  SupportTicketIntent,
  SupportTicketIntentTranslation,
  TRANSLATE_KEY_SUPPORT_TICKET_INTENT,
  true,
);
validateEnumTranslations(SupportTicketArea, SupportTicketAreaTranslation, TRANSLATE_KEY_SUPPORT_TICKET_AREA, true);
validateEnumTranslations(
  SupportTicketPriority,
  SupportTicketPriorityTranslation,
  TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY,
  true,
);
validateEnumTranslations(SupportBugKind, SupportBugKindTranslation, TRANSLATE_KEY_SUPPORT_BUG_KIND, true);
validateEnumTranslations(SupportPulseStatus, SupportPulseStatusTranslation, TRANSLATE_KEY_SUPPORT_PULSE_STATUS, true);
validateEnumTranslations(
  SupportCustomerSegment,
  SupportCustomerSegmentTranslation,
  TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT,
  true,
);
